// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__28n6V","buttons":"Footer_buttons__1L-mm"};